import { render, staticRenderFns } from "./messagepartsource.vue?vue&type=template&id=3b31fd62&"
import script from "./messagepartsource.vue?vue&type=script&lang=ts&"
export * from "./messagepartsource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports